<template>
  <div id="ErrorPage" :class="errorPageStyles">
    <div class="image-container">
      <img v-if="statusCode === 401" src="../assets/Images/Stop.png" alt="Stop Image"/>
      <img v-else src="../assets/Images/Error.png" alt="Error Image"/>
      <div class="error-text" :class="errorTextStyles">
        <div class="error-text-code">{{ statusCode }}</div>
        <div class="error-text-message">{{ errorMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  props: {
    error: {
      type: String,
      default: 'Error'
    },
    statusCode: {
      type: Number,
      default: 500
    }
  },
  computed: {
    errorMessage () {
      switch (this.statusCode) {
        case 401:
          return 'Looks like you made a wrong turn.'
        case 404:
          return 'Oops! Page not found.'
        case 429:
          return 'Too many requests. Try again later.'
        case 500:
          return 'Something went wrong.'
        default:
          return 'An error occurred. Please try again.'
      }
    },
    errorTextStyles () {
      switch (this.statusCode) {
        case 401:
          return 'error-text-404'
        default:
          return ''
      }
    },
    errorPageStyles () {
      switch (this.statusCode) {
        case 401:
          return 'error-page-404'
        default:
          return ''
      }
    }
  }
}
</script>
